export default __webpack_public_path__ + "static/thumbnail-cf4e4bc6788ac3fffae9fcb7ad4fedec.jpg";